export const situacaoDevolucaoOrcamentoEnum = {
  AGUARDANDO_AVALIACAO_FORNECEDOR: 'AGUARDANDO_AVALIACAO_FORNECEDOR',
  AGUARDANDO_AVALIACAO_BACK_OFFICE: 'AGUARDANDO_AVALIACAO_BACK_OFFICE',
  EM_ATENDIMENTO: 'EM_ATENDIMENTO',
  AGUARDANDO_ESTORNO: 'AGUARDANDO_ESTORNO',
  ENCERRADA: 'ENCERRADA'
};
